import { Outlet, createBrowserRouter } from 'react-router-dom';
import { AppOutlet } from './AppOutlet';
import { Clients, loader as clientsLoader } from './pages/clients/clients';
import { Create } from './pages/create/create';
import { History, loader as historyLoader } from './pages/history/history';
import { Detail, loader as detailLoader } from './pages/history/detail';
import { Index } from './pages';
import {
  Dashboard,
  loader as dashboardLoader,
} from './pages/dashboard/dashboard';

// TODO: add lazy import
export const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet />,
    errorElement: <h1>Oh no! We messed up 🤕</h1>,
    children: [
      {
        path: '',
        element: <Index />,
      },
      {
        path: '',
        element: <AppOutlet />,
        children: [
          {
            path: 'dashboard',
            element: <Dashboard />,
            loader: dashboardLoader,
          },
          {
            path: 'create',
            element: <Create />,
          },
          {
            path: 'history',
            children: [
              {
                path: '',
                element: <History />,
                loader: historyLoader,
              },
              {
                path: ':billId',
                element: <Detail />,
                loader: detailLoader,
              },
            ],
          },
          {
            path: 'clients',
            element: <Clients />,
            loader: clientsLoader,
          },
        ],
      },
    ],
  },
]);
